import { Component, OnInit, ElementRef, ViewChild, AfterViewInit, OnDestroy, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from './login.service'
import { SessionSetting, Resources } from '../../app.service';
import { NotificationService } from '../../shared/utils/notification.service';
import { CookieService } from 'ngx-cookie';

declare var $: any;
declare var config: any;
declare var grecaptcha: any ;
declare var Base64: any ;
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers: [LoginService]
})
export class LoginComponent implements OnInit,AfterViewInit,OnDestroy {

  // // Google reCAPTCHA表示用
  // @ViewChild('reCaprcha') reCaprchaEl: ElementRef ;
  // ログインボタン
  @ViewChild('loginBtn') loginBtnEl: ElementRef ;
//  // CAPTCHA イメージ
//  @ViewChild('captchaImg') captchaEl: ElementRef ;

  // // Google reCAPTCHA Widget
  // widgetRecaptcha = null ;
  // // 初期化用タイマー
  // waitTimer = null ;

  // captchaID 
  captchaID = null ;
  // リトライ回数
  captchaRetryCount = 0 ;

  userId = '';
  password = '';
  captchaText = '' ;
  checkboxPwdSave = false;

  validationOptions: any = {
    // Rules for form validation
    rules: {
      userId: {
        required: true
      },
      password: {
        required: true
      },
      captchaText: {
        required: true
      }
    },
    submitHandler: () => this.login()
  };

  constructor(
    private router: Router,
    private service: LoginService,
    private notifyService: NotificationService,
    private _cookieService:CookieService
  ) { }

  ngOnInit() {
    this.getCookie();
    if (!config.devMode) {
      this.router.navigate(['home']);
    } else {

    // CPATCHA イメージを取得する
    this.refreshCaptchImage() ;

    }
  }

  ngAfterViewInit() {





    // new Promise((resolve, reject)=>{
    //   if(window['grecaptcha']) {
    //     resolve(window['grecaptcha']) ;
    //   } else {
    //     // 1000ms 待つ
    //     this.waitTimer = setTimeout(()=>{
    //       this.waitTimer = null ;
    //       if(window['grecaptcha']) {
    //         resolve(window['grecaptcha']) ;
    //       } else {
    //         reject();
    //       }
    //     }, 1000);
    //   }
    // }).then(g=>{
    //   //　ログインボタンDisable
    //   this.loginBtnEl.nativeElement.disabled = true;

    //   // reCAPCHAを表示する
    //   //this.widgetRecaptcha = grecaptcha.render(this.reCaprchaEl.nativeElement,{
    //   this.widgetRecaptcha = window['grecaptcha'].render(this.reCaprchaEl.nativeElement,{
    //     'sitekey': config.google.reCaptchaSiteKey,
    //     size: this.checkMobile() ? "compact " : "normal",
    //     'callback':  response=>{
    //       //　ログインボタンDisable
    //       this.loginBtnEl.nativeElement.disabled = false ;
    //     },
    //     'expired-callback': ()=>{
    //       //　ログインボタンDisable
    //       this.loginBtnEl.nativeElement.disabled = true;
    //     }
    //   });
    // }, ()=>{
    //     console.log('Google reCAPCHA unavailable') ;
    //     // TODO ほかのCAPCHA作成
    // });
 
  }

  ngOnDestroy() {

    // // Google reCaptcha使用可の場合
    // if(window['grecaptcha'] && this.widgetRecaptcha ) {
    //   window['grecaptcha'].reset(this.widgetRecaptcha) ;
    // }
    // if(this.waitTimer) {
    //   clearTimeout(this.waitTimer) ;
    // }

  }

  // <div id="Port" (window:resize)="onResize($event)" >
  //@HostListener('window:resize', ['$event'])
  //onResize(event) {

    // // event.target.innerWidth;
    // if(window['grecaptcha'] && this.widgetRecaptcha && this.checkMobile()) {
    //   // サイズ調整 event.target.innerWidth;
    //   this.reCaprchaEl.nativeElement.style.transform = "scale(0.77)" ;
    //   this.reCaprchaEl.nativeElement.style.transformOrigin = "0 0" ;
    // }

  //}

  // CAPTCHA イメージを更新する
  refreshCaptchImage() {

    // 画像設定
    //          this.captchaEl.nativeElement.src = config.webApiDomains.main.baseUrl + '/main/cpatcha/image?CaptchaID=' +  this.captchaID + '&_dc=' + Date.now() ;
    let elem : any = document.querySelector('img.x-captcha-image') ;

    if(elem!=null) {
      if((!this.captchaID) || (this.captchaRetryCount++)%3==0) {
        // 暫定的にイメージをクリアする
  
        this.captchaID = null ;
        // CAPCHA ID を取得する
        this.service.requestCaptha().then(r => {
          //console.log(r) ;
          if(r.success) {
            this.captchaID = r.data.CaptchaID ;
            elem.src = config.webApiDomains.main.baseUrl + '/main/cpatcha/image?CaptchaID=' +  this.captchaID + '&_dc=' + Date.now() ;
          }
        }) ;
      } else {
        elem.src = config.webApiDomains.main.baseUrl + '/main/cpatcha/image?CaptchaID=' +  this.captchaID + '&_dc=' + Date.now() ;
      }
    }
  }

  // 暫定
  checkMobile() : boolean {
    // https://stackoverflow.com/questions/11381673/detecting-a-mobile-browser
    var check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window['opera']);
    return check;
  }

  login() {
    let param = {};
    $('#mainForm').serializeArray().forEach(elem => {
      param[elem.name] = elem.value;
    });

    param['captcha_id'] = this.captchaID ;
    param['captcha_challenge'] = this.captchaText ;
    

    // // reCAPTCHA有効の場合
    // if(this.widgetRecaptcha) {
    //   param['captcha_id'] = config.google.reCaptchaSiteKey;
    //   param['captcha_challenge'] = window['grecaptcha'].getResponse(this.widgetRecaptcha);
    // }

    this.service.login(param).then(r => {
      if (r.success) {
        let p = SessionSetting.get('buyProduct');
        SessionSetting.setUser(r.data);
        
        this.setCookie();
        
        if (p) {
          this.router.navigate([`buy/${p}`]);
        } else {
          this.router.navigate(['home']);
        }
      } else {
        if (r.data && r.data[0]) {
          let validator = $('#mainForm').validate();
          validator.showErrors(r.data[0]);
          validator.focusInvalid();
        }

        if (r.message) {
          this.notifyService.smallBox({
            title: Resources.getLabel('login.login'),
            content: r.message,
            color: '#C46A69',
            icon: 'fa fa-times shake animated'
          });
        }
      }
    });
  }

  //設定cookie 
  setCookie()
  {
  
    if (this.checkboxPwdSave) {
      //ユーザID
      this._cookieService.put("userId", this.userId);
      //パスワードを保存するCheckBox
      this._cookieService.put("checkboxPwdSave","true");
      System.import('script-loader!js-base64/base64.js').then(() => {
        //パスワード
        this._cookieService.put("password", Base64.encode(this.password));
      });
    } else {
      //ユーザID
      this._cookieService.remove("userId");
      //パスワード
      this._cookieService.remove("password");
      //パスワードを保存するCheckBox
      this._cookieService.remove("checkboxPwdSave");
    }

  }

  //取得するcookie
  getCookie()
  {
    //ユーザID
    let urserid = this._cookieService.get("userId");
    //パスワード
    let pwd = this._cookieService.get("password");
    //パスワードを保存するCheckBox
    let checkboxPwdSave = this._cookieService.get("checkboxPwdSave");

    let depwd;
    System.import('script-loader!js-base64/base64.min.js').then(() => {
      if (checkboxPwdSave == "true") {
        depwd = Base64.decode(pwd);
        //パスワードを保存するCheckBox
        this.checkboxPwdSave = true;
        //ユーザID
        if (urserid) {
          this.userId = urserid;
        }
        //パスワード
        if (pwd) { 
          this.password = depwd;
        }
      } else {
        //パスワードを保存するCheckBox
        this.checkboxPwdSave = false;
        //ユーザID
        this.userId = "";
        //パスワード
        this.password = "";
      }
    });


  }
}



// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/pf.main/login/login.component.ts